function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.01526 14.5862L1.77367 11.5526C1.81763 11.3767 1.90855 11.2162 2.03671 11.088L9.4873 3.63741C9.68256 3.44215 9.99914 3.44215 10.1944 3.63741L12.9873 6.43031C13.1826 6.62557 13.1826 6.94215 12.9873 7.13741L5.58889 14.5358C5.42833 14.6964 5.2179 14.7975 4.99222 14.8226L1.55554 15.2044C1.20924 15.2429 0.930749 14.9243 1.01526 14.5862Z",
  fill: "#738AA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6943 3.13761L13.5509 5.99422C13.7195 6.16276 13.9855 6.19114 14.1709 6.04129C15.4775 4.98501 16.2276 3.1708 14.8408 1.784C13.2046 0.147893 11.7078 1.42471 10.6934 2.43037C10.4973 2.62478 10.4991 2.94236 10.6943 3.13761Z",
  fill: "#738AA5"
});

function SvgEditPenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/EditPenIcon.f0b6dd8b.svg";
export { ForwardRef as ReactComponent };